export default {
  namespaced: true,
  testing: {
    title: "Provas",
    penetration: {
      title: "Teste de Penetração",
      participant: "Participante",
      required: "Este campo é obrigatório",
      perticipantRequired: "É necessário pelo menos um participante com nome e perfil",
    },
    security_box: {
      title: "Teste de caixas de segurança",
      manager: "Responsável"
    },
    testResults: "Resultados do teste",
    reopen: "Reasignar",
    reopenTest: "Reasignar prueba",
    result: "Resultado",
    type: "Tipo",
    maintenanceFormReference: " Referencia de formulario de mantenimiento",
    existingFiles: "Archivos existentes",
    date: "Fecha de registro",
    statusApprovedCanceledRejectedReagined: 'Aprobó/Rechazó/Cancelado'
  }
};
